var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKeyFill = function SvgKeyFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 4 12q0-1.25.875-2.125A2.9 2.9 0 0 1 7 9q1.25 0 2.125.875T10 12t-.875 2.125A2.9 2.9 0 0 1 7 15m0 3a5.86 5.86 0 0 0 3.475-1.1A5.8 5.8 0 0 0 12.65 14H13l1.3 1.3q.15.15.325.212.175.063.375.063t.375-.062a.9.9 0 0 0 .325-.213L17 14l1.75 1.375q.15.125.337.188a.9.9 0 0 0 .388.037q.2-.025.362-.112a1 1 0 0 0 .288-.238l2.25-2.575a1.07 1.07 0 0 0 .25-.7.86.86 0 0 0-.075-.362 1 1 0 0 0-.2-.288L21.325 10.3a1 1 0 0 0-.337-.225A1 1 0 0 0 20.6 10h-7.95q-.6-1.7-2.113-2.85T7 6Q4.5 6 2.75 7.75T1 12t1.75 4.25T7 18"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKeyFill);
export { ForwardRef as ReactComponent };